// extracted by mini-css-extract-plugin
module.exports = {"container":"e_cB","msrp":"e_dB","save":"e_eB","discount":"e_fB","price":"e_gB"};